import { cn } from "@/lib/utils"

interface EmailLinkProps {
  email?: string
  className?: string
}

/**
 * EmailLink renders an inline email link styled as a crisp crimson accent.
 * The link displays the email address with crimson text, underline, and
 * a hover state that darkens to oxblood. Use for mailto: links in policy
 * pages and contact flows.
 */
export function EmailLink({ email = "hello@coldapproach.io", className }: EmailLinkProps) {
  return (
    <a
      href={`mailto:${email}`}
      className={cn(
        "font-medium text-[var(--color-vermilion)] underline underline-offset-2 hover:text-[var(--color-oxblood)] transition-colors",
        className,
      )}
    >
      {email}
    </a>
  )
}
